// extracted by mini-css-extract-plugin
module.exports = {"picTxt":"PicTxt_picTxt__3waSc","txt":"PicTxt_txt__363XW","captionTxt":"PicTxt_captionTxt__1i4bk"};